/**
 * [mojdzial1006, paczka MD-KIT → właściciel MD-START, projekt §2.2, §3.8] REJESTR — MIEJSCE „LUDZIE” (`/moj-dzial/struktura`).
 *
 * Osobny plik, bo miejsce należy do paczki MD-START, a grupa „Zespół” — do MD-ZESPOL (`zespol.js` tylko je importuje).
 * Grupy listy to DRZEWO jednostek (`TabelaDanych grupy` zwijalne z poziomem — D-17). Sekcje pod tabelą ≤ 3 (`?sekcja=`).
 */
import { GRUPY_MOJEGO_DZIALU, miejsceZZakladki, obiektyMiejsca } from "./wspolne";

export const miejsceLudzie = miejsceZZakladki("struktura", {
    grupa: GRUPY_MOJEGO_DZIALU.zespol,
    etykieta: "Ludzie",
    zdanie: "Kto jest w Twoim zespole, kto dziś gdzie jest i jak się z nim skontaktować.",
    wzor: "S2",
    widoki: [
        { id: "wszyscy", etykieta: "Wszyscy", licznik: true },
        { id: "nieobecni-dzis", etykieta: "Nieobecni dziś", licznik: true },
    ],
    filtry: ["tylko", "stanowisko", "jednostka", "grupuj"],
    obiekty: obiektyMiejsca(),
    pasek: { szukajka: "Szukaj osoby…", wiecej: ["Rozwiń wszystkie grupy"] },
    glowa: { zdanieStanu: "23 osoby · 4 jednostki · kierują 3 · w rekrutacji 2" },
    sekcje: [
        { id: "dzialy", etykieta: "Działy i jednostki" },
        { id: "teams", etykieta: "Zespoły Teams" },
        { id: "w-tym-miesiacu", etykieta: "W tym miesiącu: rocznice i urodziny" },
    ],
    zdarzeniaNaZywo: ["dept-structure-changed", "onboarding-upserted", "supervisor-changed"],
    slowa: ["struktura", "zespół w strukturze", "działy pod Tobą", "jednostki", "kontakt", "telefon", "rocznice"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Ludzie"),
});

export default miejsceLudzie;
